module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ot7-brand-mark.03073f91.svg";